import { Routes } from '@angular/router'
import { unsavedChangesGuard } from './shared/guards/unsaved-changes-guard'
import { offerAccessGuardGuard } from './shared/guards/offer-access-guard-guard'

export const routes: Routes = [
	{
		path: '',
		loadComponent: () => import('./pages/home/home').then((x) => x.Home),
	},
	{
		path: 'sell-my-car',
		loadComponent: () => import('./pages/sell-my-car/sell-my-car').then((x) => x.SellMyCar),
	},
	{
		path: 'sell-my-car/:state',
		loadComponent: () => import('./pages/state-landing/state-landing').then((x) => x.StateLanding),
	},
	{
		path: 'sell-my-car/:state/:city',
		loadComponent: () => import('./pages/city-landing/city-landing').then((x) => x.CityLanding),
	},
	{
		path: 'how-it-works',
		loadComponent: () => import('./pages/how-it-works/how-it-works').then((x) => x.HowItWorks),
	},
	{
		path: 'about-us',
		loadComponent: () => import('./pages/about-us/about-us').then((x) => x.AboutUs),
	},
	// {
	// 	path: 'reviews',
	// 	loadComponent: () => import('./pages/reviews/reviews').then((x) => x.Reviews),
	// },
	// {
	// 	path: 'resources',
	// 	loadComponent: () => import('./pages/resources/resources').then((x) => x.Resources),
	// },
	{
		path: 'instant-offer',
		canActivate: [offerAccessGuardGuard],
		canDeactivate: [unsavedChangesGuard],
		loadComponent: () => import('./pages/instant-offer/instant-offer').then((x) => x.InstantOffer),
	},
	{
		path: '**',
		loadComponent: () => import('./pages/not-found/not-found').then((x) => x.NotFound),
	},
]
